export const rearrange = <T>(list: T[], take: number, put: number): T[] => {
    const result = [...list];
    const [removed] = result.splice(take, 1);
    result.splice(put, 0, removed);
    return result;
}
